import React from 'react';

export const isEmail = (email: string): boolean => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};
/**
 * Returns wether the string is a DD.MM.YYYY formatted date.
 */
export function isDDMMYYY(s: string): boolean {
    return /\d{2}\.\d{2}\.\d{4}/.test(s);
}

/**
 * Make string begin with uppercase char.
 */
export function toBeginUpperCase(s: string): string {
    if (!s?.length) {
        return s;
    }

    return s[0].toUpperCase() + s.slice(1);
}

/**
 * Make string begin with lowercase char.
 */
export function toBeginLowerCase(s: string): string {
    if (!s?.length) {
        return s;
    }

    return s[0].toLowerCase() + s.slice(1);
}

/**
 * Returns the last part of the path.
 */
export function getDirectoryName(path: string): string {
    if (!path.includes('\\')) {
        return path;
    }

    return path.substring(path.lastIndexOf('\\') + 1);
}

/**
 * Returns the parent path.
 * If there is no parent, returns an empty string.
 */
export function getParentDirectory(path: string): string | undefined {
    if (!path.includes('\\')) {
        return undefined;
    }

    return path.substring(0, path.lastIndexOf('\\'));
}

/**
 * Convert string to bytes.
 */
export const stringToBytes = (text: string) => {
    const length = text.length;
    const result = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
        const code = text.charCodeAt(i);
        const byte = code > 255 ? 32 : code;
        result[i] = byte;
    }
    return result;
};

export const encodeBase64String = (s: string): string => {
    const encoded = encodeURIComponent(s).replace('~', '%7E'); // char '~' must be encoded manually
    const base64 = window.btoa(encoded);

    return base64;
};

export const decodeBase64String = (base64: string): string => {
    if (!base64) return '';

    const encoded = window.atob(base64);
    const decoded = decodeURIComponent(encoded);

    if (decoded === 'undefined' || decoded === 'null') return '';

    return decoded;
};

export const getHighlightedText = (
    text: string,
    highlight = '',
): string | (string | JSX.Element)[] => {
    if (!highlight.trim()) {
        return text;
    }
    const regex = new RegExp(`(${highlight})`, 'gi');
    const parts = text.split(regex);
    return parts.map((part, index) =>
        regex.test(part) ? <mark key={`${index}_${part}`}>{part}</mark> : part,
    );
};

export const toNumberOrZero = (num?: number) => num ?? 0;
